import Vue from 'vue';
import axios from 'axios';
import users from '../../users';
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  minLength,
  maxLength
} from 'vuelidate/lib/validators';

export default {
  name: 'testStyle',
  mixins: [users, validationMixin],
  components: {

  },
  validations: {
    custkey: {
      required
    }
  },
  data: function () {
    return {
      custkey: ''
    }
  },
  computed: {
    
  },
  watch: {

  },
  created() {
    
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {

        console.log(field.$invalid && field.$dirty);
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    validateAppData() {
      this.$v.$touch();

      console.log(this.$v);

      if (!this.$v.$invalid) {
        return true;
      }
      else {
        return false;
      }
    },
    showMessageSuccess() {
      console.log(this.$store.state.notifier);
      this.$store.commit("showNotification", { type: 'alert', msg: 'aaaaaaaaaaaa' });
      //this.$parent.showNotification('success', 'Good');
    },
    showMessageWarning() {
      //this.$parent.showNotification('warning', 'Take care')
    }
  },
}
